import React, { ReactNode } from 'react';
import { useQuery } from '@apollo/client';
import { getProductQty } from '../queries/product.graphql';

export const withProductQuantity = (Component: React.FC) => (props: { children: ReactNode }) => {
  const productQty = useQuery(getProductQty).data?.productQty;
  const componentProps = {
    productQty,
  };

  return <Component {...componentProps} {...props} />;
};
